import { render } from "./momentBuyList.vue?vue&type=template&id=4002344c"
import script from "./momentBuyList.vue?vue&type=script&lang=js"
export * from "./momentBuyList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__